import React from 'react'
import './PreviousComments'
import diceIcon from './images/TTE_Icon_About.png'
import 'bootstrap/dist/css/bootstrap.min.css';

function PatchNotes() {
    return (
        <div className="PrevComments d-flex justify-content-lg-center container-fluid" >
            <div className='row container '>
                <div className='about'>
                <img src={diceIcon} class="rounded-circle diceIcon" style={{display:'inline'}} alt="dice"></img>
                    <div className='row what'>
                        <h1>12/22/2025</h1>
                        <h5>-Created Patch Notes<br/>
                        -Fixed sizing issue for Most Recent Game Added image on Homepage<br/>
                        -Added Recent Reviews to Homepage</h5>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default PatchNotes
